import React from "react";
import { Outlet } from "react-router-dom";

// Manažer → Reporting. Navigace (Přehled / Monthly / Yearly) je v sidebaru jako dropdown.
export default function ReportingLayout() {
  return <Outlet />;
}
